import config from '@/config.json';
import axios from 'axios';

export default {

	paths: {
		submit: '/submit'
	},

	submit(data) {
		return axios.post(config.base_url + this.paths.submit, { body: data });
	}

}